import HandTool from "diagram-js/lib/features/hand-tool/HandTool";
let _dragging;
var HAND_CURSOR = 'grab';
export class CustomHandTool extends HandTool {

  constructor(eventBus, canvas, dragging,
              injector, toolManager, mouse) {
    _dragging = dragging;
    super(eventBus, canvas, dragging, injector, toolManager,mouse);
  }

  activateMove(event, autoActivate,context)  {
    if(event.type === "mousedown") {
      autoActivate = false;
    }
    if (typeof autoActivate === 'object') {
      context = autoActivate;
      autoActivate = false;
    }

    _dragging.init(event, 'hand.move', {
      autoActivate: autoActivate,
      cursor: HAND_CURSOR,
      data: {
        context: context || {}
      }
    });
  }



}
